module.exports = __webpack_public_path__ + "img/bano-privado.355495f9.svg";